import { createContext } from "react";

const pokeContext = createContext();

export { pokeContext };